import * as CONST from 'Reducers/Inventory/const'

/**
 * Get inventory by city id
 *
 * @param {number} offset
 * @param {object} filters
 */
export function getInventory(first, after, filters = {}, resetSearch) {
  return {
    type: CONST.LOAD_INVENTORY,
    payload: {
      filters,
      first,
      after,
      resetSearch,
    },
  }
}

/**
 * Add a new inventory item
 * @param {object} item
 */
export function addInventoryItem(item) {
  return {
    type: CONST.ADD_INVENTORY_ITEM,
    payload: { item },
  }
}

/**
 * Add new inventory items
 * @param {object} items
 */
export function addFlyerCodes(items) {
  return {
    type: CONST.ADD_FLYER_CODES,
    payload: { items },
  }
}

/**
 * Add inventories by city id in parallel
 *
 * @param data
 * @param callbacks
 * @returns {{type, data: *, callbacks: *}}
 */
export function addInventoriesByCityIdAll(data, callbacks) {
  return {
    type: CONST.ADD_INVENTORIES_BY_CITY_ID_ALL,
    data,
    callbacks,
  }
}

/**
 * Get inventory types
 *
 * @returns {{type}}
 */
export function getInventoryTypes() {
  return {
    type: CONST.GET_INVENTORY_TYPES,
  }
}

/**
 * Edit inventory
 *
 * @param inventoryId
 * @param payload
 * @param callbacks
 * @returns {{type, inventoryId: *, payload: *, callbacks: *}}
 */
export function editInventory(inventoryId, payload, callbacks) {
  return {
    type: CONST.EDIT_INVENTORY,
    inventoryId,
    payload,
    callbacks,
  }
}

/**
 * Edit inventory in parallel
 *
 * @param data
 * @param callbacks
 * @returns {{type, data: *, callbacks: *}}
 */
export function editInventoryAll(data, callbacks) {
  return {
    type: CONST.EDIT_INVENTORY_ALL,
    data,
    callbacks,
  }
}

/**
 * Move an inventory item
 * @param {object} inventoryMovement
 */
export function processInventoryMovement(inventoryMovement) {
  return {
    type: CONST.MOVE_INVENTORY,
    payload: { inventoryMovement },
  }
}

/**
 * Get a specific inventory item
 * @param {number} id
 */
export function getInventoryItem(id) {
  return {
    type: CONST.GET_INVENTORY_ITEM,
    payload: { id },
  }
}

/**
 * Delete flyer code
 * @param {object} items
 */
export function deleteFlyerCode(id) {
  return {
    type: CONST.DELETE_FLYER_CODE,
    payload: { id },
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Inventory/actions.js